import axiosInstance from "./axiosInstance";

export const filtrarCabana = async (adminId, cabana) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/filtrarCabana?adminId=${adminId}&cabana=${cabana}`
  );
};
